<script>
    import { CONFIG } from '../config.js';
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang = 'pl';
    import { bridgeParams } from '../Player/bridgeParams.js';
    export let bridgeState = {};
    export let viewState = {
        isVotingRunning: false,
        isVotingOver: false,
        isSolutionVisible: false,
    };
    export let gameCode;
    export let GAMEURL;
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();
    let initTimer = 25;
    export let isTrainerSummoned = false;
    export let isGameOn = false;
    export let isGameEnd = false;
    $: console.log(isGameOn);
</script>

<div class="zulu-state">
    <h3 class="heading-tertiary u-full-line">{texts[lang].timer}</h3>
    <button
        class="btn btn__smaller"
        on:click={() => dispatch('start_timer', { timer: initTimer })}
        >{texts[lang].init_timer}</button
    >

    <div class="btn-number">
        <button on:click={() => initTimer--} />
        <input type="number" id="timer" bind:value={initTimer} />
        <button class="plus" on:click={() => initTimer++} />
    </div>
    <slot />
    <h3 class="heading-tertiary u-full-line">{texts[lang].bridge_state}</h3>
    <div class="bridge-state">
        {#each bridgeParams as param}
            {#if !param.isBoolean}
                <div
                    class="player__img"
                    style="background: url({CONFIG.filesUrl}/img/bridge-parts/{bridgeState[
                        param.name
                    ]}.png)"
                />
            {:else}
                <div
                    class="player__img"
                    style="background: url({CONFIG.filesUrl}/img/bridge-parts/{bridgeState[
                        param.name
                    ]
                        ? param.name
                        : param.name + '_none'}.png"
                />
            {/if}
        {/each}

        <div
            class="u-attention"
            class:u-attention--active={isTrainerSummoned}
            on:click={() => {
                isTrainerSummoned = false;
                dispatch('desummon_trainer');
            }}
        >
            <h3>{texts[lang].attention}</h3>
            <h3 class="u-attention__hover">{texts[lang].attention__hover}</h3>
        </div>
        <!-- klasa do uruchomienia animacji przyzwania trenera(dodatkowa)-.u-attention--active -->
    </div>
    <hr class="u-flex-break" />
    <h3 class="heading-tertiary u-full-line">{texts[lang].vote}</h3>
    <button
        class="btn btn__smaller"
        disabled={viewState.isVotingRunning || !isGameOn || isGameEnd}
        class:btn--inactive={viewState.isVotingRunning ||
            !isGameOn ||
            isGameEnd}
        on:click={() => dispatch('start_voting')}
        >{texts[lang].start_vote}</button
    >
    <button
        class="btn btn__smaller"
        disabled={!viewState.isVotingRunning ||
            viewState.isVotingOver ||
            isGameEnd}
        class:btn--inactive={!viewState.isVotingRunning ||
            viewState.isVotingOver ||
            isGameEnd}
        on:click={() => dispatch('break_voting')}
        >{texts[lang].break_vote}
    </button>
    <button
        class="btn btn__smaller"
        disabled={!viewState.isVotingRunning ||
            viewState.isVotingOver ||
            isGameEnd}
        class:btn--inactive={!viewState.isVotingRunning ||
            viewState.isVotingOver ||
            isGameEnd}
        on:click={() => dispatch('end_voting')}
        >{texts[lang].end_vote}
    </button>
    <button
        on:click={() => {
            window.open(`${GAMEURL}?game=${gameCode}&player=trainer`, '_blank');
        }}
        class="btn btn__smaller"
        disabled={!viewState.isVotingRunning ||
            !viewState.isVotingOver ||
            isGameEnd}
        class:btn--inactive={!viewState.isVotingRunning ||
            !viewState.isVotingOver ||
            isGameEnd}>{texts[lang].result}</button
    >

    <button
        class="btn btn__smaller"
        disabled={!viewState.isVotingOver ||
            isGameEnd ||
            (viewState.isSheepingActive && !viewState.isSheepingOver)}
        class:btn--inactive={!viewState.isVotingOver ||
            isGameEnd ||
            (viewState.isSheepingActive && !viewState.isSheepingOver)}
        on:click={() => {
            dispatch('toggle_solution');
        }}
        >{!viewState.isSolutionVisible ? texts[lang].show : texts[lang].hide}
        {texts[lang].solution}</button
    >
    <button
        class="btn btn__smaller"
        disabled={!viewState.isVotingOver || isGameEnd}
        class:btn--inactive={!viewState.isVotingOver || isGameEnd}
        on:click={() => {
            dispatch('toggle_sheep');
        }}
        >{!viewState.isSheepingActive ? texts[lang].show : texts[lang].hide}
        {texts[lang].sheep}</button
    >
    <button
        class="btn btn__smaller"
        disabled={!viewState.isSheepingActive ||
            viewState.isSheepingOver ||
            isGameEnd}
        class:btn--inactive={!viewState.isSheepingActive ||
            viewState.isSheepingOver ||
            isGameEnd}
        on:click={() => {
            dispatch('sheeping_ended');
        }}>{texts[lang].sheep_end}</button
    >
    <button
        class="btn btn__smaller"
        disabled={!viewState.isVotingOver || !isGameOn || isGameEnd}
        class:btn--inactive={!viewState.isVotingOver || isGameEnd || !isGameOn}
        on:click={() => {
            dispatch('close_game');
        }}
    >
        {texts[lang].close_game}</button
    >
</div>

<!-- <p>Rada:</p>
{#each playerList.council as council}
  <p> {council.playerName}</p>  
{:else}
  <p>Jeszcze nikt</p> 
{/each}

<p>Inżynierzy:</p>
{#each playerList.engineers as engineer}
<p>{engineer.playerName}</p>
{:else}
    <p>to nie są droidy których szukacie</p>
{/each} -->
